export const getAuthenticationAll = state => state.authentication;
export const getAuthentication = state => state.authentication.authentication;
export const getAuthenticationFailure = state => state.authentication.loginFailure;
export const getSSOAuthenticationFailure = state => state.authentication.ssoLoginFailure;
export const getAuthenticationFailureMsg = state => state.authentication.loginFailureMsg;
export const getUserProfile = state => state.authentication.userProfile;
export const getLoy3Profile = state => state.authentication.loy3Profile;
export const getLoy3ProfileData = state => state.authentication.loy3ProfileData;
export const getLoggedIn = state => state.authentication.loggedIn;
export const getLoy3AuthToken = state => state.authentication.authToken;
export const getRegistrationInfo = state => state.authentication.registrationInfo;
export const getLocale = state => state.authentication.loy3Profile && state.authentication.loy3Profile.locale;
// Token temporal, hablar con Fran Muñoz
export const tokenRegistration = ''